import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
import nordicWalkingFImg from '@/assets/landing/nordic-walking-f.png'

const schema: LandingScreenSchema = {
	order: ['LandingHead', 'LandingTitle', 'LandingImage', 'LandingProgressLoader', 'LandingFooter'],

	components: {
		LandingTitle: (): LandingComponentsConfig['LandingTitle'] => ({
			title: 'Nordic Walking for Weight Loss<br/>Based on Your Age',
			size: 'small',
		}),

		LandingImage: (): LandingComponentsConfig['LandingImage'] => ({
			img: nordicWalkingFImg,
			customStyles: {
				width: 'calc(100% + 40px)',
				maxWidth: 'none',
				marginLeft: '-20px',
				marginRight: '-20px',
				marginTop: 'var(--size-64)',
				marginBottom: 'var(--size-64)',
			},
		}),

		LandingProgressLoader: (): LandingComponentsConfig['LandingProgressLoader'] => ({
			duration: 3500,
		}),
	},
}

export default schema
